import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createTemplate } from 'API/Templates/createTemplate';
import { uploadTemplateImage } from 'API/Templates/uploadTemplateImage';

const useCreateTemplate = (onSuccess, onError) => {
    const queryClient = useQueryClient();

    const create = async ({ newImage, ...templateData }) => {
        const response = await createTemplate(templateData);
        if (newImage) {
            await uploadTemplateImage(templateData.id, newImage);
        }
        return response.data;
    };

    return useMutation({
        mutationFn: create,
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ['Templates'] });
            if (onSuccess) {
                onSuccess(data);
            }
        },
        onError: (error) => {
            if (onError) {
                onError(error);
            }
        },
    });
};

export default useCreateTemplate;
